export const translations = {
  dialogTitle: {
    pt: 'Deletar rota',
	en: 'Delete route',
	es: 'Eliminar ruta',
	de: 'Route löschen',
  },
  dialogDescription: {
	pt: 'Tem certeza que deseja deletar esta rota? Esta ação não pode ser desfeita.',
    en: 'Are you sure you want to delete this route? This action cannot be undone.',
    es: '¿Está seguro de que desea eliminar esta ruta? Esta acción no se puede deshacer.',
    de: 'Sind Sie sicher, dass Sie diese Route löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  },
  justification: {
    pt: 'Justificativa',
    en: 'Justification',
    es: 'Justificación',
    de: 'Rechtfertigung',
  },
  cancelButton: {
    pt: 'Fechar',
    en: 'Close',
    es: 'Cerrar',
    de: 'Schließen',
  },
  deleteButton: {
    pt: 'Deletar',
    en: 'Delete',
    es: 'Eliminar',
    de: 'Löschen',
  },
  routeDeleteSuccessMessage: {
	pt: 'Rota deletada com sucesso.',
	en: 'Route deleted successfully.',
	es: 'Ruta eliminada con éxito.',
	de: 'Route erfolgreich gelöscht.',
  },
  routeDeleteErrorMessage: {
	pt: 'Erro ao deletar a rota.',
	en: 'Error deleting route.',
	es: 'Error al eliminar la ruta.',
	de: 'Fehler beim Löschen der Route.',
  }
};
